import {Component, ChangeDetectorRef} from '@angular/core';
import { AppComponent } from "../../../app.component";
import { ConfigService } from '../../../config/config.service';
import {AuthenticatedResult, OidcSecurityService, UserDataResult} from "angular-auth-oidc-client";
import {AuthService} from "../../../auth/services/auth-service";
import {userInfo} from "node:os";
import {take} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
  selector: 'nav-bar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent  {

    protected userdata$: Observable<UserDataResult>;
    protected isAuthenticated$: Observable<AuthenticatedResult>;

    constructor(public readonly appComponent: AppComponent,
                public readonly configService: ConfigService,
                protected readonly authService: AuthService) {
        this.userdata$ = this.authService.getUser();
        this.isAuthenticated$ = this.authService.isAuthenticated();
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}
